__turbopack_context__.v({
  "ctaSection": "simple-header-section-module-scss-module__PVLm8W__ctaSection",
  "heading": "simple-header-section-module-scss-module__PVLm8W__heading",
  "subtitle": "simple-header-section-module-scss-module__PVLm8W__subtitle",
});
